import { z } from 'zod';

/**
 * The stored shape of `clara_configuration` (CUR-1161): the organisation's Clara enablement.
 *
 * `enabledFrom` is the instant Clara was switched on for the org, as a UTC ISO 8601 timestamp;
 * `null` means not enabled, whatever the `enable-clara` flag says. The trigger pipeline compares
 * every claim's `createdAt` against it, so claims that predate the enablement never wake the
 * agent (CUR-1028: "claims that exist before release are untouched"). Lives in shared because the
 * generic configuration procedures normalise what an operator submits against this same schema.
 */
export const claraConfigurationSchema = z.object({ enabledFrom: z.iso.datetime().nullable() }).strict();
export type ClaraConfiguration = z.infer<typeof claraConfigurationSchema>;
